import type { Media } from '@/types/MediaType';

type FormatType = 'thumbnail' | 'small' | 'medium' | 'large' | 'xlarge';

type StrapiImageSize = Pick<Media, 'url' | 'width' | 'height' | 'alternativeText'>;

/**
 * Returns the best available image URL and dimensions from Strapi formats.
 */
export default function getStrapiImageSize(
  image: Media | null | undefined,
  format: FormatType = 'large',
): StrapiImageSize | null {
  if (!image) return null;

  if (image.formats && image.formats[format]) {
    const { url, width, height } = image.formats[format];
    return {
      url,
      width,
      height,
      alternativeText: image.alternativeText,
    };
  }

  // Fallback to original
  if (image.url && image.width && image.height) {
    return {
      url: image.url,
      width: image.width,
      height: image.height,
      alternativeText: image.alternativeText,
    };
  }

  return null;
}
